<template>
	<nav class="booking-calendar-week-desktop-head">
		<div class="row">
			<!-- Select provider -->
			<div class="col-xs-7 margin-bottom-xs-1">
				<ToggleSelectProviderDesktop />
			</div>
			<!-- Select location -->
			<div class="col-xs-7 margin-bottom-xs-1 xs-location">
				<ToggleSelectLocationDesktop />
			</div>
 			<!-- Select view type -->
			<div class="col-xs-5 text-right margin-bottom-xs-1">
				<SelectCalendarViewType />
			</div>
		</div>

		<div class="row">
			<SelectProvider />
		</div>
		
		<div class="row row-location">
			<SelectLocation />
		</div>

		<div class="row flex-align-center">
			<!-- Date info -->
			<div class="col-xs-5 margin-top-xs-1 margin-bottom-xs-2">
				<p class="capitalize margin-bottom-xs-0">
					{{ dates.active.monthName }}
					{{ year }}, Vecka
					{{ dates.active.week }}
				</p>
				<!-- Selected treatment -->
				<div v-if="activities.selected">
					<p class="margin-bottom-xs-0">
						Vald tjänst:
						<span v-html="activities.selected.activity_name"></span>
					</p>
				</div>
			</div>
			<!-- Date navigation -->
			<div class="col-xs-7 margin-top-xs-1 margin-bottom-xs-2">
				<p class="text-align-right-md margin-bottom-xs-0">
					<a
						href="#"
						class="nk-button nk-button-today margin-right-xs-1"
						v-if="!dateIsInThePast"
						@click.prevent="setupActiveDates('reset')"
						>Idag</a
					>
					<a
						href="#"
						class="link-arrow-left margin-right-xs-1"
						@click.prevent="setupActiveDates('back')"
						v-if="!dateIsInThePast"
						>Vecka {{ dates.active.previousWeek }}</a
					>
					<strong>Vecka {{ dates.active.week }}</strong>
					<a
						href="#"
						class="link-arrow-right margin-left-xs-1"
						@click.prevent="setupActiveDates('forward')"
						>Vecka {{ dates.active.nextWeek }}</a
					>
				</p>
			</div>
		</div>
	</nav>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import ToggleSelectProviderDesktop from "./ToggleSelectProviderDesktop.vue";
import ToggleSelectLocationDesktop from "./ToggleSelectLocationDesktop.vue";
import SelectProvider from "./SelectProvider.vue";
import SelectLocation from "./SelectLocation.vue";
import SelectCalendarViewType from "./SelectCalendarViewType.vue";

export default {
	components: {
		ToggleSelectProviderDesktop,
		ToggleSelectLocationDesktop,
		SelectProvider,
		SelectLocation,
		SelectCalendarViewType,
	},
	computed: {
		...mapState(["ui", "dates", "activities", "providers", "locations"]),
		...mapGetters(["dateIsInThePast"]),
		year() {
			if (this.dates.active.niceDate) {
				return this.dates.active.niceDate.substring(0, 4);
			}
			return this.dates.active.year;
		},
	},
	methods: {
		...mapActions([
			"setupActiveDates",
			"toggleSelectingProvider",
			"toggleSelectingLocation",
			"calendarViewType",
		]),
	},
};
</script>